import { MASK_TYPE, NumberMaskConfig } from '@certemy/ui-components';
import { ROLE_CODES, ROLE_NAMES } from 'constants/role.constants';
import { LogFieldOption } from 'interfaces/log-step.interface';

export const DEFAULT_EXPIRATION_DATE_DAYS = 365;

export enum COMPLIANCE_CRITERIA_LOG_NEW {
  ENTRIES = 1,
  UNITS = 2,
}

export enum COMPLIANCE_CRITERIA {
  ENTRIES = 1,
  HOURS = 2,
}

export enum SUPERVISOR_IS_ACCEPTED_STEP {
  NOT = 0,
  ACCEPTED,
}

export enum LOG_STEP_RESPONSIBLE_TO_COMPLETE {
  PROFESSIONAL = 1,
  SUPERVISOR = 2,
  BOTH = 3,
}

const LOG_STEP_RESPONSIBLE_TO_COMPLETE_NAMES = {
  [LOG_STEP_RESPONSIBLE_TO_COMPLETE.PROFESSIONAL]: '{professional}',
  [LOG_STEP_RESPONSIBLE_TO_COMPLETE.SUPERVISOR]: '{supervisorTitle}',
  [LOG_STEP_RESPONSIBLE_TO_COMPLETE.BOTH]: 'Both ({supervisorTitle} & {professional})',
};

export const logStepResponsibleToCompleteOptions: LogFieldOption[] = [
  {
    id: LOG_STEP_RESPONSIBLE_TO_COMPLETE.SUPERVISOR,
    name: LOG_STEP_RESPONSIBLE_TO_COMPLETE_NAMES[LOG_STEP_RESPONSIBLE_TO_COMPLETE.SUPERVISOR],
    templateName: LOG_STEP_RESPONSIBLE_TO_COMPLETE_NAMES[LOG_STEP_RESPONSIBLE_TO_COMPLETE.SUPERVISOR],
  },
  {
    id: LOG_STEP_RESPONSIBLE_TO_COMPLETE.PROFESSIONAL,
    name: LOG_STEP_RESPONSIBLE_TO_COMPLETE_NAMES[LOG_STEP_RESPONSIBLE_TO_COMPLETE.PROFESSIONAL],
  },
  {
    id: LOG_STEP_RESPONSIBLE_TO_COMPLETE.BOTH,
    name: LOG_STEP_RESPONSIBLE_TO_COMPLETE_NAMES[LOG_STEP_RESPONSIBLE_TO_COMPLETE.BOTH],
    templateName: LOG_STEP_RESPONSIBLE_TO_COMPLETE_NAMES[LOG_STEP_RESPONSIBLE_TO_COMPLETE.BOTH],
  },
];

export enum SUPERVISOR_APPROVAL_TYPE {
  NO_APPROVAL,
  SINGLE_APPROVAL,
  SECONDARY_APPROVAL,
}

export const SUPERVISOR_APPROVAL_TYPE_NAME = {
  [SUPERVISOR_APPROVAL_TYPE.NO_APPROVAL]: '',
  [SUPERVISOR_APPROVAL_TYPE.SINGLE_APPROVAL]: 'Single {supervisorTitle} Approval',
  [SUPERVISOR_APPROVAL_TYPE.SECONDARY_APPROVAL]: 'Secondary {supervisorTitle} Approval',
};

export const logStepSupervisorApprovalTypeOptions: LogFieldOption[] = [
  {
    id: SUPERVISOR_APPROVAL_TYPE.NO_APPROVAL,
    name: SUPERVISOR_APPROVAL_TYPE_NAME[SUPERVISOR_APPROVAL_TYPE.NO_APPROVAL],
    disabled: true,
  },
  {
    id: SUPERVISOR_APPROVAL_TYPE.SINGLE_APPROVAL,
    name: SUPERVISOR_APPROVAL_TYPE_NAME[SUPERVISOR_APPROVAL_TYPE.SINGLE_APPROVAL],
    templateName: SUPERVISOR_APPROVAL_TYPE_NAME[SUPERVISOR_APPROVAL_TYPE.SINGLE_APPROVAL],
  },
  {
    id: SUPERVISOR_APPROVAL_TYPE.SECONDARY_APPROVAL,
    name: SUPERVISOR_APPROVAL_TYPE_NAME[SUPERVISOR_APPROVAL_TYPE.SECONDARY_APPROVAL],
    templateName: SUPERVISOR_APPROVAL_TYPE_NAME[SUPERVISOR_APPROVAL_TYPE.SECONDARY_APPROVAL],
  },
];

export const logStepFilledByOptions: LogFieldOption[] = [
  {
    id: ROLE_CODES.PROFESSIONAL,
    name: 'Filled by {professional}',
  },
  {
    id: ROLE_CODES.SUPERVISOR,
    name: 'Filled by {supervisorTitle}',
    templateName: 'Filled by {supervisorTitle}',
  },
];

export const logStepSecondarySupervisorFilledByOptions: LogFieldOption[] = [
  {
    id: ROLE_CODES.SUPERVISOR,
    name: 'Filled by Secondary {supervisorTitle}',
    templateName: 'Filled by Secondary {supervisorTitle}',
  },
];

export const defaultSupervisorTitle = ROLE_NAMES[ROLE_CODES.SUPERVISOR];
export const defaultUnitLabel = 'units';
export const defaultCriteriaLabel = 'entries';

export const logNumberMaskConfig: {
  positive: NumberMaskConfig;
  half: NumberMaskConfig;
  oneDecimal: NumberMaskConfig;
  default: NumberMaskConfig;
} = {
  positive: {
    maskType: MASK_TYPE.POSITIVE_INTEGER,
  },
  half: {
    maskType: MASK_TYPE.MULTIPLE_OF_HALF,
  },
  oneDecimal: {
    maskType: MASK_TYPE.ONE_DECIMAL,
  },
  default: {
    maskType: MASK_TYPE.DEFAULT,
  },
};

export enum CRUD_MODE {
  READ,
  EDIT,
}

export enum SUPERVISOR_BOTH_CASE_MODE {
  PENDING,
  ACCEPT,
  ADD,
  READ,
  EDIT_PREVIEW,
  EDIT,
}

export enum SUPERVISOR_TAB_TYPE {
  PRIMARY,
  SECONDARY,
}

export const SecondarySupervisorConfirmationTextTemplate =
  'I have reviewed the information provided by {professionalName} and their {supervisorLabel}, {primarySupervisorName} and attest to the contents of this submission.';

export const DefaultInvitationMessage = '{first_name} {last_name} from {organization_name} is inviting you to Certemy.';
export const DefaultInvitationMessagePlaceholder = 'Enter optional text';
